import * as tslib_1 from "tslib";
import { IconsActionTypes } from './types';
export function getSvgIcons() {
    var _this = this;
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var result;
        return tslib_1.__generator(this, function (_a) {
            result = {
                type: IconsActionTypes.GET_ICONS_SVG,
            };
            return [2 /*return*/, dispatch(result)];
        });
    }); };
}
;
